import React from 'react';

import { Route, Switch } from 'react-router-dom';

// 外殼
import Layout from './components/Layout';
// 主頁
import Home from './containers/Home';
import HouseView from './containers/HouseView';
import Login from './containers/Login';
import Purchase from './containers/Purchase';
import PurchaseComplete from './containers/PurchaseComplete';
import TSR from './containers/TSR';


const Router = ({ data, ...props }) => (
  <Switch>
    <Route exact path="/" render={() => <Layout main={Home} {...props} />} />
    <Route exact path="/index" render={() => <Layout main={Home} {...props} />} />
    <Route exact path="/HouseView" render={() => <Layout main={HouseView} {...props} />} />
    <Route exact path="/Login" render={() => <Layout main={Login} {...props} />} />
    <Route exact path="/Purchase" render={() => <Layout main={Purchase} {...props} />} />
    <Route exact path="/PurchaseComplete" render={() => <Layout main={PurchaseComplete} {...props} />} />
    <Route exact path="/TSR" render={() => <Layout main={TSR} {...props} />} />
  </Switch>
);

export default Router;
